import React from "react";
import type { FC } from "react";

import { createDisplayNameForCoreInputTextElement } from "../../utils/getDisplayName";
import { createTestIdForCoreInputTextElement } from "../../utils/getTestId";

import type { InputTextLabelProps } from "../../types";

import classes from "./CoreInputTextLabel.styl";

const INPUT_TEXT_LABEL_TEST_ID = createTestIdForCoreInputTextElement("label");

const CoreInputTextLabel: FC<InputTextLabelProps> = ({ children }) => {
    return children ? (
        <span className={classes["label"]} data-tsid={INPUT_TEXT_LABEL_TEST_ID}>
            {children}
        </span>
    ) : null;
};

CoreInputTextLabel.displayName =
    createDisplayNameForCoreInputTextElement("Label");

export default CoreInputTextLabel;
